"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.getLocale = exports.default = void 0;
exports.initTranslation = initTranslation;
var _axios = _interopRequireDefault(require("axios"));
var _i18next = _interopRequireDefault(require("i18next"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _isValid = _interopRequireDefault(require("date-fns/isValid"));
const loadResources = async (prefix, locale) => {
  let response = {};
  try {
    response = await _axios.default.get(`${prefix}/locales/${locale}.json`);
  } catch (error) {
    global.console.error(`Locale ${locale} does not exist!`, error);
  }
  return response.data;
};
const defaultFormat = (value, formatPattern) => {
  if ((0, _isValid.default)(value)) return (0, _format.default)(value, formatPattern);
  return value;
};
const getLocale = async config => {
  const localeConfig = {};
  try {
    localeConfig.lng = config.locale;
    localeConfig.resources = await loadResources(config.appPrefix, config.locale);
  } catch (error) {
    global.console.warn('Error occurred while app config was loading!', error);
  }
  return localeConfig;
};
exports.getLocale = getLocale;
function initTranslation({
  resources,
  lng
}, formatFn) {
  const options = {
    lng,
    fallbackLng: false,
    resources,
    debug: false,
    interpolation: {
      escapeValue: false,
      format: formatFn || defaultFormat
    }
  };
  _i18next.default.init(options, error => {
    if (error) {
      global.console.error('Error while locale was loading.', error);
    }
  });
}
const init = async (config, formatFn) => {
  initTranslation(await getLocale(config), formatFn);
};
exports.init = init;
var _default = exports.default = _i18next.default;